import Button from '@mui/material/Button';

type Props = {
    isValid: boolean,
    isSubmitting: boolean
};

export default function SubmitButton(props: Props) {

  return (
    <Button disabled={!props.isValid || props.isSubmitting} className="primary login" size="small" type="submit">Enviar</Button>
  );
}